<template>
  <span class="save-status" :class="{ 'save-status--dirty': dirty }">
    <span v-if="dirty" class="save-status__dot"></span>
    <span v-if="dirty">Unsaved changes</span>
    <span v-else-if="saved">All changes saved</span>
    <span v-else>Not saved yet</span>
  </span>
</template>

<script>
// Quiet save-state line for editors with an explicit Save button. Sits in
// the editor's header or footer bar beside the actions. The same markup and
// styles live as page-local copies in EditCampaign, PaymentPageEditor and
// RequestFormEditor; migrate those here when touched.
export default {
  name: 'save-status',
  props: {
    dirty: { type: Boolean, default: false },
    saved: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
.save-status {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.6);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.save-status--dirty { color: rgba(255, 255, 255, 0.95); }
.save-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e14eca;
  box-shadow: 0 0 0 3px rgba(225, 78, 202, 0.18);
  animation: save-status-pulse 1.8s ease-in-out infinite;
}
@keyframes save-status-pulse {
  0%, 100% { box-shadow: 0 0 0 3px rgba(225, 78, 202, 0.18); }
  50%      { box-shadow: 0 0 0 5px rgba(225, 78, 202, 0.08); }
}
.white-content .save-status { color: rgba(0, 0, 0, 0.6); }
.white-content .save-status--dirty { color: rgba(0, 0, 0, 0.9); }
</style>
